import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';

const CONTACT_EMAIL = 'hello@mnemetic.com';

const footerLink = {
    color: 'text.secondary',
    '&:hover': {
        color: 'text.primary',
    },
};

function Copyright() {
    return (
        <React.Fragment>
            {'© '}
            <Link color="inherit" href="https://mnemetic.com">
                Mnemetic LLC
            </Link>{' '}
            {new Date().getFullYear()}
        </React.Fragment>
    );
}

export default function MnemeticAppFooter() {
    return (
        <Typography
            component="footer"
            sx={{ display: 'flex', borderTop: 1, borderColor: 'primary.light' }}
        >
            <Container sx={{ my: 8 }}>
                <Grid container spacing={5}>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="h6" marked="left" gutterBottom>
                            Contact
                        </Typography>
                        <Box sx={{ py: 0.5 }}>
                            <Link href={`mailto:${CONTACT_EMAIL}`} underline="hover" sx={footerLink}>
                                {CONTACT_EMAIL}
                            </Link>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: { sm: 'flex-end' } }}>
                        <Typography variant="body2" color="text.secondary">
                            <Copyright />
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        </Typography>
    );
}
